<div class="confirmGeneric">
  <div class="confirmGeneric-wrapper">


    <div class="confirmGeneric-wrapper-header">

      <div class="headerTitleContainer">
        @if (!title) {
          <epmax-typo class="headerTitle" [color]="'secondary'">{{'Labels.Warning' | translate}}</epmax-typo>
        }
        @if (!!title) {
          <epmax-typo class="headerTitle" [color]="'secondary'">{{title| translate}}</epmax-typo>
        }
      </div>
      <div>
        <epmax-icon [size]="20" [color]="'secondary'" [name]="'close'" (click)="dismiss()"></epmax-icon>
      </div>

    </div>
    @if (showWarningMessage) {
      <epmax-alert [type]="'danger'" [label]="showWarningMessage"></epmax-alert>
    }
    @if (!!subTitle) {
      <div class="confirmGeneric-wrapper-container">
        <epmax-typo class="headerTitle" [name]="'body1'" [color]="'secondary'">{{subTitle | translate}}</epmax-typo>
      </div>
    }

    <div class="confirmGeneric-wrapper-footer">

      @if (!!closeButtonText) {
        <epmax-button [data-automation-id]="'confirm-dismiss'"
          [label]="closeButtonText"
          (click)="dismiss()"
          size="medium"
          [style]="'outline'"
          [withBorder]="false"
          type='secondary'>
        </epmax-button>
      }
      @if (!!submitButtonText) {
        <epmax-button [data-automation-id]="'confirm-submit'"
          [type]="getSubmitButtonColor"
          [label]="submitButtonText"
          (click)="submit()"
          [disabled]="submitButtonDisabled"
          size="medium">
        </epmax-button>
      }

    </div>

  </div>
</div>
